import api from './axiosInstance';

// Cola de triage de correos no ubicables (EEPP): respuestas de notaría no
// identificadas por la cascada + correos de remitentes desconocidos.
// Backend: EscriturasInboundTriageController (api/escrituras/inbound-triage).

export const getTriageList = async ({ status = 'pending', take = 20, skip = 0 } = {}, signal) => {
  const response = await api.get('/escrituras/inbound-triage', {
    params: { status, take, skip },
    signal,
  });
  return response.data;
};

export const getTriageItem = async (id, signal) => {
  try {
    const response = await api.get(`/escrituras/inbound-triage/${id}`, { signal });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
};

export const getTriageAttachmentViewUrl = async (id, index, signal) => {
  try {
    const response = await api.get(
      `/escrituras/inbound-triage/${id}/attachments/${index}/view-url`,
      { signal }
    );
    return response.data?.url || null;
  } catch (error) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
};

export const getOpenDispatches = async (signal) => {
  const response = await api.get('/escrituras/inbound-triage/open-dispatches', { signal });
  return response.data || [];
};

export const resolveTriageAsDispatch = async (id, { dispatchId, outcome, attachmentIndex, notes } = {}, signal) => {
  const response = await api.post(
    `/escrituras/inbound-triage/${id}/resolve-dispatch`,
    { dispatchId, outcome: outcome ?? null, attachmentIndex: attachmentIndex ?? null, notes: notes ?? null },
    { signal }
  );
  return response.data;
};

export const assignTriageToCase = async (id, { caseId, notes } = {}, signal) => {
  const response = await api.post(
    `/escrituras/inbound-triage/${id}/assign-case`,
    { caseId, notes: notes ?? null },
    { signal }
  );
  return response.data;
};

export const dismissTriage = async (id, { reason } = {}, signal) => {
  const response = await api.post(
    `/escrituras/inbound-triage/${id}/dismiss`,
    { reason: reason ?? null },
    { signal }
  );
  return response.data;
};
